//import api from '../../api'

// initial state
import api from "../../api";

const state = {
    banks: [],
    payment: {
        status: null,
        _links: {}
    },
    order: null
};

// getters
const getters = {};

// actions
const actions = {
    _getOrderConfirm({commit}, secret){
        return new Promise((resolve, reject)=>{
            api
                .get('/order-confirm/' + secret)
                .then(response => {
                    commit('_setOrder', response.data.data);
                    resolve(response.data.data);
                }).catch(error =>{
                reject(error);
            });
        });
    },
    _makeOrder({}, data){
        return new Promise((resolve, reject)=>{
            api
                .post('/order', data)
                .then(response => {
                    resolve(response.data);
                }).catch(error =>{
                reject(error);
            });
        });
    },
    _makeOrderPayment({}, data){
        return new Promise((resolve, reject)=>{
            api
                .post('/order-payment', data)
                .then(response => {
                    resolve(response.data.url);
                }).catch(error =>{
                reject(error);
            });
        });
    },
    _getPayment({commit}, paymentId){
        return new Promise((resolve, reject)=>{
            api
                .get('/payment/'+paymentId)
                .then(response => {
                    commit('_setPayment', response.data.payment);
                    resolve(response.data.url);
                }).catch(error =>{
                reject(error);
            });
        });
    },
    _getPaymentByInvoice({commit}, invoice){
        return new Promise((resolve, reject)=>{
            api
                .get('/paymentbyinvoice/'+invoice)
                .then(response => {
                    resolve(response.data.data);
                }).catch(error =>{
                reject(error);
            });
        });
    }
};

// mutations
const mutations = {
    _setBanks(state, banks){
        state.banks = banks;
    },
    _setPayment(state, payment){
        state.payment = payment;
    },
    _setOrder(state, order){
        state.order = order;
    }
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}
